var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.047.462 7.491 7.627v17.45H1.24V.461h13.808z",
    stroke: "#1C1A37",
    strokeWidth: 0.923
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.462 1.114 6.424 6.424h-6.424V1.114z",
    stroke: "#1C1A37",
    strokeWidth: 0.923
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#E5A033"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.923
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 12.007 3.282 3.3 3.281-3.432M11.814 7v8.308"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 18.507 11-.014"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadFile);
export default __webpack_public_path__ + "static/media/ic_download_file.16ff3648fc6cb042720c5451c2fa7929.svg";
export { ForwardRef as ReactComponent };